import { render, staticRenderFns } from "./ServicePackageProgramUpdate.vue?vue&type=template&id=5e2d2975&scoped=true"
import script from "./ServicePackageProgramUpdate.vue?vue&type=script&lang=js"
export * from "./ServicePackageProgramUpdate.vue?vue&type=script&lang=js"
import style0 from "./ServicePackageProgramUpdate.vue?vue&type=style&index=0&id=5e2d2975&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2d2975",
  null
  
)

export default component.exports